import React from 'react';
import TextLink from '../TextLink/TextLink';

const LinkWithArrow = ({ children, href, target, additionalClassNames = [], dataEventLocation }) => (
    <TextLink
        href={href}
        className={['link-with-arrow link-l', ...additionalClassNames].join(' ')}
        target={target}
        rel="nofollow"
        dataEventLocation={dataEventLocation}
    >
        {children}
    </TextLink>
);

export default LinkWithArrow;
